<template>
  <div class="pending_wrap">
    <step-status :step="$route.meta.step" class="mt55"></step-status>
    <h1>Demo result</h1>
    <!-- no show -->
    <div class="letter" v-if='$route.query.status=="noshow"'>
      <p>
        It looks like your HAWO demo didn't take place. <br />Kindly contact your recruiter via email at
        <a :href="`mailto:${recruiter_email}`">{{recruiter_email}}</a> to further assist you.
      </p>
      <p>
        Kind Regards, <br /> HAWO Recruitment Team
      </p>
    </div>
    <!-- failed -->
    <div class="letter" v-if='$route.query.status=="failed"'>
      <p>Dear {{full_name}},</p>
      <p>Thank you for your application. Unfortunately, we are unable to move forward in the recruitment process with your application.</p>
      <p>We appreciate the time and effort you have put into applying, and wish you the best of luck in your job search.</p>
      <p>Kind Regards,<br/>HAWO Recruitment Team</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      full_name: '',
      recruiter_email: ''
    }
  },
  created: function() {
    //获取老师全名
    this.$http.get('/demo/getTutorInfo').then(d => {
      if (d.data.code == '75000') {
        this.full_name = d.data.res.tutor.full_name
        this.recruiter_email =
          d.data.res.tutor.interviewer_info.interviewer_email
      }
    })
  }
}
</script>
<style lang='less' scoped>
.pending_wrap {
  height: 752px;
  width: 1000px;
  margin: 0 auto;
  & > h1 {
    margin-top: 55px;
    font-size: 24px;
    font-weight: bolf;
    color: #ffb400;
  }
  div.letter {
    box-sizing: border-box;
    height: 384px;
    background: #f7f7f7;
    border-radius: 10px;
    margin-top: 30px;
    padding: 40px 30px;
    p {
      padding-bottom: 24px;
      line-height: 20px;
      color: #1e1e1e;
      a {
        color: #fd4c6e;
      }
    }
  }
  .download {
    position: fixed;
    top: 166px;
    right: 80px;
    & > ul {
      width: 75px;
      li {
        float: left;
        margin-top: 6px;
        background-color: #fff;
        border-radius: 5px;
        a {
          display: inline-block;
          box-sizing: border-box;
          vertical-align: middle;
          width: 75px;
          height: 75px;
          text-align: center;
          padding-top: 52px;
          background: url('~@img/donwload_icons.png') no-repeat
            center 10px;
          box-shadow: 0 0 2px 2px #ecebec;
          border-radius: 5px;
          &.mypage_icon {
            background-image: url('~@img/mypage_icons.png');
          }
          &:hover {
            border: 1px solid #fcc800;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// result.vue?f9935264